<script>
  export let description;
  export let title;
  export let image;
  export let link;
</script>

<main class="py-6">
  <div class="md:w-[40vw] w-full relative group">
    <img src={image} alt="img" class="w-full rounded-lg" />
    <div
      class="absolute inset-0 w-full justify-center items-center flex-col flex opacity-0 group-hover:opacity-100 group-hover:backdrop-blur-md duration-100 group-hover:rounded-lg"
    >
      <h1 class="text-[#a42e37] font-bold">Build with {description}</h1>
      <button class="btn btn-primary">
        <a href={link} target="_blank">{title}</a>
      </button>
    </div>
  </div>
</main>
